import { useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { IStore } from "../../store/IStore";
import { AnyAction, bindActionCreators, Dispatch } from "redux";
import { logout } from "../../store/actions/LoginActions";
import { thunkCreateErrorNotification } from "../../store/actions/NotificationActions";
import { connect, ConnectedProps } from "react-redux";
import { Box, Button, CssBaseline, Grid, Paper, Theme, Typography, useTheme } from "@mui/material";
import {
  thunkDownloadPkPass,
  thunkDownloadPkPassForCustomerIdentificationNumber,
} from "../../store/actions/PkPassDownloadAction";
import { KNISTR_BLUE } from "../atoms/ImsMaterialTheme";
import harborNewYearBackground from "../atoms/images/harbor-new-year-background.png";
import NotificationBar from "../notification/NotificationBar";

const PkPassDownloadPage = (props: ThunkProps) => {
  const theme = useTheme();
  const classes = styles(theme);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  // /cards/download links carry cardItemNumber, /passes/download links passNumber — both name the same card item.
  const passNumber = params.get("cardItemNumber") ?? params.get("passNumber");
  const customerIdentificationNumber = params.get("customerIdentificationNumber");
  const token = params.get("token");

  const triggerDownload = useCallback(() => {
    if (passNumber && token) {
      props.thunkDownloadPkPass(passNumber, encodeURIComponent(token));
    } else if (customerIdentificationNumber && token) {
      props.thunkDownloadPkPassForCustomer(customerIdentificationNumber, encodeURIComponent(token));
    }
  }, [props, passNumber, customerIdentificationNumber, token]);

  useEffect(() => {
    triggerDownload();
  }, [triggerDownload]);

  return (
    <>
      <NotificationBar />
      <CssBaseline />

      <Paper sx={classes.login}>
        <Grid container spacing={3} style={{ padding: theme.spacing(2) }}>
          <Grid item xs={12} style={{ fontWeight: "bold", textAlign: "center" }}>
            <Typography variant="h5">Ihr Pass wird in Kürze heruntergeladen</Typography>
            <Typography variant="body1">Sollte der Vorgang nicht automatisch starten, klicken Sie bitte auf</Typography>
            <Box marginTop={2}>
              <Button variant="contained" color="primary" onClick={triggerDownload}>
                Jetzt herunterladen
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      <Box component="div" sx={classes.blueBackground}>
        <Box component="div" sx={classes.pictureBackground}></Box>
      </Box>
    </>
  );
};

const styles = (theme: Theme) => ({
  blueBackground: {
    backgroundColor: KNISTR_BLUE,
  },
  pictureBackground: {
    width: "100%",
    minHeight: "100vh",
    maxWidth: "100%",
    backgroundImage: `url(${harborNewYearBackground})`,
    backgroundSize: "cover",
    opacity: 0.35,
  },
  login: {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "476px",
    marginTop: "-200px",
    marginLeft: "-238px",
    zIndex: 1001,
    padding: theme.spacing(3),
  },
});
const mapStateToProps = (_state: IStore) => ({});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) =>
  bindActionCreators(
    {
      logout,
      thunkDownloadPkPass,
      thunkDownloadPkPassForCustomer: thunkDownloadPkPassForCustomerIdentificationNumber,
      thunkCreateErrorNotification,
    },
    dispatch
  );
const connector = connect(mapStateToProps, mapDispatchToProps);
type ThunkProps = ConnectedProps<typeof connector>;
export default connector(PkPassDownloadPage);
